export default {
  install(Vue) {
    Vue.prototype.$doubleTap = {
      lastTapTime: {},
      doubleTapDelay: 200,
      singleTapTimer: {},

      getKeyId(key, hasShift) {
        return hasShift ? `shift_${key}` : key;
      },

      handle(key, {
        double = () => {},
        single = () => {},
        immediateSingle = () => {}
      } = {}) {
        const hasShift = key.startsWith('shift_');
        const baseKey = hasShift ? key.replace('shift_', '') : key;
        const keyId = this.getKeyId(baseKey, hasShift);

        const now = Date.now();
        const lastTap = this.lastTapTime[keyId];
        immediateSingle()

        if (now - lastTap < this.doubleTapDelay) {
          clearTimeout(this.singleTapTimer[keyId]);
          double();
          this.lastTapTime[keyId] = 0;
        } else {
          this.lastTapTime[keyId] = now;

          clearTimeout(this.singleTapTimer[keyId]);
          this.singleTapTimer[keyId] = setTimeout(() => {
            if (this.lastTapTime[keyId] === now) {
              single();
              this.lastTapTime[keyId] = 0;
            }
          }, this.doubleTapDelay);
        }
      }
    }
  }
}